// Best-effort display name for a candidate/application. The move
// surfaces hand us different row/card shapes — some carry
// `contact.name`, others only `contact.first_name`/`last_name`, and the
// contacts list keeps the name at the row root — so try them in order
// before falling back to a generic word.
export const getCandidateDisplayName = (application: any): string => {
  const contact = application?.contact ?? {};
  const fullName = [contact.first_name, contact.last_name]
    .filter(Boolean)
    .join(' ')
    .trim();
  return (
    contact.name?.trim() ||
    fullName ||
    application?.candidate?.name?.trim() ||
    application?.name?.trim() ||
    'candidate'
  );
};
